function toggleActiveFecCategory(event) {
    if (dragging) return;

    var target = event.target.closest(".fec-category-links a");
    if(target) {
        event.stopPropagation();

        // Toggle active class on category links
        document.querySelectorAll(".fec-category-links a:not([data-category='" + target.getAttribute("data-category") + "'])").forEach(function(el){
            el.classList.remove("active");
        });
        target.classList.add("active");

        // Display all
        if(target.getAttribute("data-category") == "all") {
            document.querySelectorAll(".financial-education-center-listing .wrapper .card.fec").forEach(function(el){
                el.classList.add("is-shown");
            });
        }
        // Display only the selected category
        else {
            document.querySelectorAll(".financial-education-center-listing .wrapper .card.fec:not([data-category='" + target.getAttribute("data-category") + "'])").forEach(function(el){
                el.classList.remove("is-shown");
            });
            document.querySelectorAll(".financial-education-center-listing .wrapper .card.fec[data-category='" + target.getAttribute("data-category") + "']").forEach(function(el){
                el.classList.add("is-shown");
            });
        }
    }
}

document.addEventListener("click", toggleActiveFecCategory);
document.addEventListener("touchend", toggleActiveFecCategory);